import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CtaInterface } from '../../../@core/models/site-material-data.model';
import { DataService } from '../../../@core/services/data.service';
import { SafePipe } from '../../../@core/pipes/safe.pipe';
import { SafeUrl } from '@angular/platform-browser';
import { AnalyticsService } from '../../../@core/services/analytics.service';
import { GoogleAnalyticsService } from '../../../@core/services/google-analytics.service';
import { FontsService } from 'src/app/@core/services/fonts.service';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class MaterialCtaComponent implements OnInit, OnDestroy {
  title: string;
  text: string;
  titleSize: string;
  textSize: string;
  backgroundColor: string;
  textColor: string = '';
  titleColor: string = '';
  buttonStyle: string = '';
  buttonIcon: string = '';
  secondaryButtonIcon: string = '';
  buttonBackgroundColor: string = '';
  buttonTextColor: string = '';
  fontWeight: string = '';
  buttonText: string = 'Get Started';
  buttonLink: SafeUrl;
  subscription: Subscription;
  data: CtaInterface;
  position: number = 0;
  moduleInfo: string;
  activatePadding: boolean = false;
  secondButtonText: string;
  secondButtonLink: string;
  buttonsDisplay: number;
  allElementAnimation: string;
  textAnimation: string;
  buttonAnimation: string;
  hovered: number;
  loading: boolean = true;
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(
    private safePipe: SafePipe,
    private dataService: DataService,
    private analyticsService: AnalyticsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private fontsService:FontsService
  ) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.buttonAnimation = this.data.animation.button != '' ? this.data.animation.button : undefined;

    }
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.text = this.data.text;
    this.buttonIcon = this.data.buttonIcon;
    this.secondaryButtonIcon = this.data.secondaryButtonIcon;
    this.fontWeight = this.data.fontWeight;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.buttonStyle = this.data.buttonStyle ? this.data.buttonStyle : '';
    this.buttonBackgroundColor = this.data.buttonBackgroundColor ? this.data.buttonBackgroundColor : '';
    this.buttonTextColor = this.data.buttonTextColor ? this.data.buttonTextColor : '';
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.textSize = this.data.textSize;
    this.buttonText = this.data.buttonText;
    this.secondButtonText = this.data.secondButtonText;
    this.secondButtonLink = this.data.secondButtonLink;
    this.buttonsDisplay = this.data.buttonsDisplay;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.buttonLink = this.data.buttonLink ? this.data.buttonLink : '';
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.loading = false;
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
    if (this.buttonStyle == 'style3') {
      window.document.body.style.setProperty(
        "--button-background-cta",
        this.buttonBackgroundColor
      );
      window.document.body.style.setProperty(
        "--button-color-cta",
        this.buttonTextColor
      );
    } else if (this.buttonStyle == 'style2') {
      window.document.body.style.setProperty(
        "--button-background-cta",
        this.buttonTextColor
      );
      window.document.body.style.setProperty(
        "--button-color-cta",
        this.buttonBackgroundColor
      );
    }
  }
  navigateTo(fragment: string) {
    if (fragment) {
      fragment = fragment.replace('/#', '')
      setTimeout(() => {
        if (document.getElementById(fragment)) {
          document.getElementById(fragment).scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  clickExternalLink(link) {
    const currentSite = this.dataService.site$.getValue();
    if (currentSite) {
      this.analyticsService.trackConversion(currentSite, 'click');
    }
    // window.open(link, "_blank");
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  trackEvent(buttonName: string) {
    this.subscription = this.dataService.getCurrentSite().subscribe(currentSite => {
      if (currentSite.googleAnalyticsPixel) {
        this.googleAnalyticsService.eventEmitter('click', 'click', buttonName + '-CtaComponent-' + this.position, 'click', buttonName + '-CtaComponent-' + this.position);
      }
      if (currentSite.facebookPixel) {
        this.googleAnalyticsService.FbEventEmitter('Click', 'cta_button', buttonName + '-CtaComponent-' + this.position, 'click');
      }
    })
  }
}
